export const CURRENCY = {
    USD: '$',
    GBP: '£',
    EUR: '€'
}

export const IMAGE_FORMATS = ['application/pdf', 'image/jpeg', 'image/png', 'image/gif']
export const ARCHIVE_FORMATS = ['application/zip', 'application/x-rar-compressed', 'application/x-rar', 'application/x-zip-compressed',
    '.zip', '.rar', 'application/vnd.rar', 'application/octet-stream', 'application/x-zip-compress'
    , 'application/x-rar-compress']